import { useEffect } from 'react';
import { useAuth } from '../components/AuthContext';
import { useNotifications } from '../contexts/NotificationContext';
import { useUnreadCount } from '../lib/chat/hooks/useUnreadCount';
import { badgeService } from '../services/BadgeService';

/**
 * Syncs the native app icon badge count with
 * unread notifications + unread chat messages.
 */
export const useAppBadge = () => {
  const { user } = useAuth();
  const { unreadCount: notifUnread } = useNotifications();
  const chatUnread = useUnreadCount(user?.id || '');

  useEffect(() => {
    const total = notifUnread + chatUnread;
    if (total > 0) {
      badgeService.set(total);
    } else {
      badgeService.clear();
    }
  }, [notifUnread, chatUnread]);

  // Request badge permission once on mount
  useEffect(() => {
    if (user) {
      badgeService.requestPermission();
    }
  }, [user]);
};
